import React, {Component} from 'react';
import "./index.css"
import HomeContainer from "../../content/Home";

class ViewerProfile extends Component {
    render() {

        return (
            <HomeContainer
                match={this.props.match}
                history={this.props.history}
                location={this.props.location}/>
        );
    }
}


export default ViewerProfile;
